import { render } from "./App.vue?vue&type=template&id=1b0008dc"
const script = {}

import "./App.vue?vue&type=style&index=0&id=1b0008dc&lang=css"

import exportComponent from "/vercel/path0/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__